import {
  SHAREABLE_SCOPE_KINDS,
  type ShareableScopeKind,
} from "../../../../shared/rbac/permissions";
import {
  BUILTIN_ROLES,
  type BuiltinRoleId,
} from "../../../../shared/rbac/roles";

export type ScopeKind = ShareableScopeKind;

const EDITABLE_SCOPES = {
  space: true,
  connected_app: true,
  skill: true,
  network: false,
  service_account: false,
} as const satisfies Record<ShareableScopeKind, boolean>;

export type EditableScopeKind = {
  [K in ShareableScopeKind]: (typeof EDITABLE_SCOPES)[K] extends true
    ? K
    : never;
}[ShareableScopeKind];

export function isEditableScopeKind(
  kind: ScopeKind | null
): kind is EditableScopeKind {
  return kind !== null && EDITABLE_SCOPES[kind];
}

export type RoleInfoLite = { id: string; scopeKind: string };

type GrantLike = {
  builtinRoleId: string | null;
  customRoleId: string | null;
};

function isShareableScopeKind(kind: string | undefined): kind is ScopeKind {
  return (
    kind != null && (SHAREABLE_SCOPE_KINDS as readonly string[]).includes(kind)
  );
}

export function inferScopeKind(
  grant: GrantLike,
  rolesMap: ReadonlyMap<string, RoleInfoLite>
): ScopeKind | null {
  if (grant.builtinRoleId) {
    const kind = BUILTIN_ROLES[grant.builtinRoleId as BuiltinRoleId]?.scopeKind;
    if (isShareableScopeKind(kind)) return kind;
  }
  if (grant.customRoleId) {
    const kind = rolesMap.get(grant.customRoleId)?.scopeKind;
    if (isShareableScopeKind(kind)) return kind;
  }
  return null;
}
